import { render, staticRenderFns } from "./PriorTemplate.vue?vue&type=template&id=c5a41b8a&"
import script from "./PriorTemplate.vue?vue&type=script&lang=js&"
export * from "./PriorTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports